var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "orders-layout" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 mb-4" }, [
        _c("table", { staticClass: "table table-order mb-3" }, [
          _c("tbody", [
            _c("tr", [
              _c("td", { staticClass: "order-details-label" }, [
                _vm._v("Order Date:")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "order-detail" }, [
                _vm._v(_vm._s(_vm.__(_vm.orderData.order_date, ["date"])))
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "order-details-label" }, [
                _vm._v("Client Name:")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "order-detail" }, [
                _vm._v(_vm._s(_vm.__(_vm.clientName, ["titleCase"])))
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "order-details-label" }, [
                _vm._v("Phone:")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "order-detail" }, [
                _vm._v(_vm._s(_vm._.get(_vm.orderData, "phone", "___")))
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "order-details-label" }, [
                _vm._v("Email:")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "order-detail" }, [
                _vm._v(_vm._s(_vm._.get(_vm.orderData, "email", "___")))
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("address", [
          _c("h3", { staticClass: "table-heading" }, [_vm._v("Billed To:")]),
          _vm._v(" "),
          _c("table", { staticClass: "table table-order" }, [
            _c("tbody", [
              _c("tr", [
                _c("td", [_vm._v("Name")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.__(_vm.clientName, ["titleCase"])))
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "vert-top" }, [_vm._v("Address")]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm.orderData.b_address1 ||
                        _vm.orderData.b_street ||
                        "___"
                    )
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.orderData.b_address2 || "___")
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.orderData.b_suburb || "___")
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.orderData.b_city || "___")
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.orderData.b_country || "___")
                  ),
                  _c("br"),
                  _vm._v(
                    "\n                                " +
                      _vm._s(_vm.orderData.b_postcode || "___")
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("br")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("h3", { staticClass: "table-heading" }, [_vm._v("Shipped To:")]),
        _vm._v(" "),
        _c("table", { staticClass: "table table-order" }, [
          _c("tbody", [
            _c("tr", [
              _c("td", [_vm._v("Name")]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.__(_vm.clientName, ["titleCase"])))])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "vert-top" }, [_vm._v("Address")]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n                            " +
                    _vm._s(
                      _vm.orderData.s_address1 ||
                        _vm.orderData.s_street ||
                        "___"
                    )
                ),
                _c("br"),
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.orderData.s_address2 || "___")
                ),
                _c("br"),
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.orderData.s_suburb || "___")
                ),
                _c("br"),
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.orderData.s_city || "___")
                ),
                _c("br"),
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.orderData.s_country || "___")
                ),
                _c("br"),
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.orderData.s_postcode || "___") +
                    "\n                        "
                )
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "panel panel-default" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._.isEmpty(_vm.customOrderData)
            ? _c("div", { staticClass: "alert alert-secondary" }, [
                _vm._v("\n                    No information\n                ")
              ])
            : _c("div", { staticClass: "panel-body" }, [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-order" }, [
                    _c(
                      "tbody",
                      [
                        _c("tr", [
                          _c("td", [_vm._v("Order Type")]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(_vm.orderData.order_type))])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.customOrderData, function(value, key) {
                          return _c("tr", { key: key }, [
                            _c("td", { staticStyle: { width: "30%" } }, [
                              _vm._v(_vm._s(_vm.__(key, ["titleCase"])) + ":")
                            ]),
                            _vm._v(" "),
                            _c("td", {
                              domProps: { innerHTML: _vm._s(_vm.format(value)) }
                            })
                          ])
                        }),
                        _vm._v(" "),
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-left vert-top",
                              attrs: { valign: "top" }
                            },
                            [_vm._v("Comment:")]
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c("address", [
                              _vm._v(
                                "\n                                            " +
                                  _vm._s(_vm.orderData.comment || "---") +
                                  "\n                                        "
                              )
                            ])
                          ])
                        ])
                      ],
                      2
                    )
                  ])
                ])
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _vm.uploadImage
          ? _c("div", { staticClass: "panel panel-default" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "panel-body" }, [
                _c("div", { staticClass: "img-cont" }, [
                  _c("img", {
                    staticClass: "w-100",
                    attrs: { src: _vm._.imgPath(_vm.uploadImage) }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "mt-2" }, [
                    _vm._v(
                      _vm._s(_vm.uploadImageName) + "\n                        "
                    ),
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn-primary btn-icon btn-rounded btn-sm float-right",
                        attrs: {
                          href:
                            "/asset/" +
                            _vm._.get(_vm.uploadImage, "id", "null") +
                            "?download",
                          target: "_blank"
                        }
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("get_app")
                        ]),
                        _vm._v(" DOWNLOAD IMAGE")
                      ]
                    )
                  ])
                ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "table-heading" }, [_vm._v("Order summary")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "table-heading" }, [_vm._v("Upload image")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aef5fd1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aef5fd1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/OrderDetailComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5aef5fd1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/OrderDetailComponent.vue
// module chunks = 0